<template>
  <LGOverlayPanel
    ref="menuUsuario"
    posicao="direita"
    ignore-event-bus
    :sidebar="isMobile && modoSidebar"
    :style="{
      zIndex: $lg.config.zIndex.menu,
      width: '400px',
    }"
    aria-haspopup="listbox"
  >
    <div class="lg-aa-layout__topo__menuUsuario p-m-0">
      <div class="lg-aa-layout__topo__menuUsuario__dropdown">
        <div class="lg-aa-layout__topo__menuUsuario__dropdown__dados">
          <LGAvatar
            id="avatarColaborador"
            :avatar="dadosUsuario.foto"
            :alt="dadosUsuario.nome"
            :upload-icon="permitirAlterarFoto"
            :tamanho="50"
            @click.stop="alterarFoto($event)"
          />
          <div
            class="
              lg-aa-layout__topo__menuUsuario__dropdown__dados__colaborador
            "
          >
            <h4>{{ dadosUsuario.nome }}</h4>
            <span>{{ dadosUsuario.cargo }}</span>
          </div>
        </div>

        <hr class="lg-aa-separador" />
        <ul class="lg-aa-layout__topo__menuUsuario__dropdown__menu">
          <li
            v-for="(menu, index) in dadosUsuario.menus"
            :key="'menuUsuario__' + index"
          >
            <LGIconeLabel
              :label="menu.descricao"
              :icone="menu.icone"
              :color="menu.color"
              @click="abrirItemMenuUsuario(menu)"
            />
          </li>
        </ul>
      </div>
    </div>
  </LGOverlayPanel>
</template>

<script>
import LGAvatar from 'lg-vue-components/avatar';
import LGIconeLabel from 'lg-vue-components/iconeLabel';
import LGOverlayPanel from 'lg-vue-components/overlayPanel';

export default {
  name: 'LGMenuUsuario',
  components: {
    LGAvatar,
    LGIconeLabel,
    LGOverlayPanel,
  },
  props: {
    dadosUsuario: {
      type: Object,
      required: true,
    },
    modoSidebar: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['uploadFoto'],
  computed: {
    isMobile() {
      return this.$lg.breakpoint.xsOnly;
    },
    layoutEmPreview() {
      return this.$store.state.layout.preview;
    },
    rotaPadrao() {
      return this.$lg.config.rotaPadrao;
    },
    configuracaoFoto() {
      return this.dadosUsuario.configuracao || {};
    },
    permitirAlterarFoto() {
      return this.configuracaoFoto.alterarFoto;
    },
  },
  mounted() {
    if (this.$eventBus) {
      this.$eventBus.on('toggleMenuUsuario', this.toggleMenuUsuario);
    }
  },
  unmounted() {
    if (this.$eventBus) {
      this.$eventBus.off('toggleMenuUsuario');
    }
  },
  methods: {
    toggleMenuUsuario(event = null) {
      this.$refs.menuUsuario.togglePanel(event);
    },
    forcarFechamentoMenuUsuario() {
      this.$refs.menuUsuario.fecharOverlay();
    },
    abrirItemMenuUsuario(menu) {
      if (this.layoutEmPreview === false) {
        const acaoCustomizada = this.$store.getters['layout/getAcaoCustomizada'](menu.codigo);

        if (acaoCustomizada) {
          acaoCustomizada.call(this, menu);
        } else {
          this.$store.commit('layout/setMenuAtivo', menu);

          this.$abrirFuncao({
            tipo: 2, // 2 = MENU_USUARIO
          }, menu);
        }
      }
      this.toggleMenuUsuario();
    },
    alterarFoto(evento) {
      this.$emit('uploadFoto', evento);
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.lg-aa-overlayPanel__conteudo) {
  padding-bottom: 0;
  padding-top: 1rem;
}
</style>
